import React from "react";
import { withTranslation } from "react-i18next";
import { Form, Select, Typography } from "antd";

const { Text } = Typography;
const { Option } = Select;

const BillVoidedFormItemComponent = ({
  t,
  style,
  defaultValue,
  required = false,
  editable = true,
  showLabel = false,
  strong = false,
  name = "billVoided",
  recordInfo
}) => {
  return (
    <Form.Item
      name={recordInfo ? [recordInfo.key, recordInfo.dataIndex] : name}
      label={showLabel ? <Text strong={strong}>{t("form.bill_voided.label")}</Text> : null}
      style={style}
      colon={false}
      rules={[
        {
          required,
          message: t("form.bill_voided.select_error_required")
        }
      ]}
    >
      {editable ? (
        <Select defaultValue={defaultValue} placeholder={t("form.bill_voided.placeholder")} style={style}>
          <Option value={false}>{t("form.bill_voided.no_text")}</Option>
          <Option value={true}>{t("form.bill_voided.yes_text")}</Option>
        </Select>
      ) : (
        <Text>{defaultValue ? `${defaultValue}` : "-"}</Text>
      )}
    </Form.Item>
  );
};

const BillVoidedFormItem = withTranslation()(BillVoidedFormItemComponent);

export { BillVoidedFormItem };
